<template>
	<div>
		<v-layout row wrap>
			<v-flex lg6>
				<v-card style="margin-left: 10px; margin-right: 10px; margin-top:10px; margin-top: 10px;">
					<v-toolbar flat dense cad>
						<v-toolbar-title class="subheading">{{ performanceReview.employee.fullName }}</v-toolbar-title>
						<v-spacer></v-spacer>
						<!-- <v-btn icon flat @click="print">
          <v-badge color="red" overlap>

            <v-icon medium>print</v-icon>
          </v-badge>
        </v-btn> -->
					</v-toolbar>
					<v-list two-line>
						<v-list-tile inactive>
							<v-list-tile-action>
								<v-avatar size="36px">
									<img :src="getAvatar(performanceReview.employee.id)" alt="avatar" class="avatar-img" />
								</v-avatar>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>{{ performanceReview.position.title }}</v-list-tile-title>
								<v-list-tile-sub-title>Job Title</v-list-tile-sub-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list>
					<div class="pd-container">
						<h2>Position Purpose</h2>
						<p>{{ performanceReview.position.description }}</p>
					</div>
				</v-card>
			</v-flex>
		</v-layout>

		<v-divider style="margin-top:30px; margin-bottom: 20px;"></v-divider>

		<v-layout row wrap class="reflect">
			<v-flex sm6>
				<v-card class="mb-4" style="margin-left: 10px; margin-right: 10px; margin-top:10px; margin-top: 10px;">
					<v-toolbar flat dense cad color="info" dark>
						<v-toolbar-title class="subheading">Employee Data - {{ performanceReview.employee.fullName }}</v-toolbar-title>
						<v-spacer></v-spacer>
					</v-toolbar>
					<v-divider></v-divider>

					<v-card-text class="">
						<performance-review-report-items :report-items="employeeItems" :filled-out-by="performanceReview.employee"></performance-review-report-items>
					</v-card-text>
				</v-card>
			</v-flex>

			<v-flex sm6>
				<v-card class="mb-4" style="margin-left: 10px; margin-right: 10px; margin-top:10px; margin-top: 10px;">
					<v-toolbar flat dense cad>
						<v-toolbar-title class="subheading">Reviewer Data - {{ performanceReview.reviewer.fullName }}</v-toolbar-title>
						<v-spacer></v-spacer>
					</v-toolbar>
					<v-divider></v-divider>

					<v-card-text class="">
						<performance-review-report-items :report-items="reviewerItems" :filled-out-by="performanceReview.reviewer"></performance-review-report-items>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import PerformanceReviewReportItems from '@/components/performanceReview/PerformanceReviewReportItems';
	import typeFriendlyMixin from '@/mixins/typeFriendlyMixin';
	import avatarMixin from '@/mixins/avatarMixin';

	export default {
		props: {
			performanceReview: {
				required: true
			}
		},
		components: {
			PerformanceReviewReportItems
		},
		computed: {
			reviewerItems() {
				return this.sortItems(this.performanceReview.reviewerSubmit.items);
			},
			employeeItems() {
				return this.sortItems(this.performanceReview.employeeSubmit.items);
			}
		},
		methods: {
			print() {
				window.print();
			},
			sortItems(itemsToSort) {
				// group by type
				let groupedByType = _.groupBy(itemsToSort, 'item.type');
				let result = [];

				for (let type in groupedByType) {
					result.push({
						type: type,
						typeFriendly: this.getTypeFriendly(type, true),
						items: []
					});

					// group by category
					let groupedByCategory = _.groupBy(groupedByType[type], 'item.category');

					for (let category in groupedByCategory) {
						result[result.length - 1].items.push({
							category: category,
							items: groupedByCategory[category]
						});
					}
				}

				let sortOrder = [1, 2, 5, 0, 3, 4];
				let resultsOrdered = [];
				for (let i = 0; i < sortOrder.length; i++) {
					for (let x = 0; x < result.length; x++) {
						if (result[x].type == sortOrder[i]) {
							resultsOrdered.push(result[x]);
						}
					}
				}
				return resultsOrdered;
			}
		},
		mixins: [typeFriendlyMixin, avatarMixin]
	};
</script>

<style scoped>
	@media print {
		/* ... */
		.v-navigation-drawer {
			display: none;
		}
		.v-content {
			padding: 0 !important;
		}
		.v-alert {
			display: none;
		}
		.item {
			page-break-inside: avoid;
		}
		.reflect {
			page-break-before: avoid !important;
		}
	}
</style>
